import { render, staticRenderFns } from "./GLanguageChip.vue?vue&type=template&id=4211e0cf&scoped=true&"
import script from "./GLanguageChip.vue?vue&type=script&lang=js&"
export * from "./GLanguageChip.vue?vue&type=script&lang=js&"
import style0 from "./GLanguageChip.vue?vue&type=style&index=0&id=4211e0cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4211e0cf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VChip,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4211e0cf')) {
      api.createRecord('4211e0cf', component.options)
    } else {
      api.reload('4211e0cf', component.options)
    }
    module.hot.accept("./GLanguageChip.vue?vue&type=template&id=4211e0cf&scoped=true&", function () {
      api.rerender('4211e0cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GLanguageChip.vue"
export default component.exports